exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainProduct__price{font-weight:700;font-size:24px;margin:0 0 20px;word-spacing:-10px}.mainProduct__oldPrice{text-decoration:line-through}.mainProduct__newPrice{color:#ce2c52;margin:0 0 0 25px}@media only screen and (max-width:935px){.mainProduct__price{font-weight:700;font-size:36px;margin:0 0 10px}.mainProduct__newPrice{margin:0 0 0 25px}}@media only screen and (max-width:730px){.mainProduct__price{font-weight:700;font-size:36px;margin:0 0 10px}.mainProduct__newPrice{margin:0 0 0 25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f17177d","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainPrice.vue
// module id = 25
// module chunks = 0